module.exports = __webpack_public_path__ + "static/media/brad-wrenn.87bea378.md";